import { configureStore } from "@reduxjs/toolkit";

import authReducer from "./auth";
import navMobileReducer from "./navMobile";
import { fetchUserProfileApi } from "./auth/fetchUserProfileThunk";
import { listingSlice } from "./listing";
import { fetchListingSlice } from "./listing/fetchListingsforUser";

import { fetchSliderApi } from "./slider/fetchSliderImages";
import { fetchSpecificListingApi } from "./listing/fetchSpecialListing";
import { fetchStateListingApi } from "./listing/fetchStateListingThunk";
import { specialListingsSlice } from "./listing/specialStateReducer";
import { themeSlice } from "./theme/theme";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    listing: listingSlice.reducer,
    navMobile: navMobileReducer,
    specialStateListings: specialListingsSlice.reducer,
    themeSlice: themeSlice.reducer,
    [fetchUserProfileApi.reducerPath]: fetchUserProfileApi.reducer,
    [fetchListingSlice.reducerPath]: fetchListingSlice.reducer,
    [fetchSliderApi.reducerPath]: fetchSliderApi.reducer,
    [fetchSpecificListingApi.reducerPath]: fetchSpecificListingApi.reducer,
    [fetchStateListingApi.reducerPath]: fetchStateListingApi.reducer
  },
  middleware: (getDefaultMiddleware) => {
    return getDefaultMiddleware().concat(
      fetchUserProfileApi.middleware,
      fetchListingSlice.middleware,
      fetchSliderApi.middleware,
      fetchSpecificListingApi.middleware,
      fetchStateListingApi.middleware
    );
  }
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
